import React, { Component } from 'react';
import './Spinner.css';
import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Hider extends Component {
	constructor(props){
		super(props)
		const{handles, invertHandles, children}=props;
		this._children = children;
		if(invertHandles===undefined||invertHandles===null)
			this._invertHandles = false;
		else 
			this._invertHandles = invertHandles;
		
		this._handles = handles;
		this._handlesChanged = this._handlesChanged.bind(this);
		handles.addEventListener('change', this._handlesChanged);
		this.state={visible:false};
	}
	_handlesChanged(e){
		const visible = this._invertHandles?(!e.hasHandles):e.hasHandles;
		this.setState({visible:visible});
	}
	render() {
		let className ="hider";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className}>
			{this._children}
			</div>);
	}
}
